"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapseNumberRange = void 0;
/**
 * https://tc39.es/ecma402/#sec-collapsenumberrange
 */
function CollapseNumberRange(result) {
    return result;
}
exports.CollapseNumberRange = CollapseNumberRange;
